export default "<div class=\"spinner-wrapper\">\n  <div class=\"donut\"></div>\n</div>";